const mixin = {
  props: {
    id: {
      type: [String, Number],
      description: "Dashboard item id."
    },
    itemName: {
      type: String,
      description: "Dashboard item name."
    },
    itemNumber: {
      type: String,
      description: "Dashboard item number."
    },
    service: {
      type: String,
      description:
        "Description of the service, eg 'Registration of a Private Company'."
    },
    status: {
      type: String,
      description: "Defines Pill/Tag level and colour."
    },
    statusCode: {
      type: String,
      description: "Code for Pill/Tag level."
    },
    createdDate: String,
    expireDate: String,
    referenceNumber: String,
    app: String,
    reasons: Object,
    pill: {
      type: Boolean,
      default: false,
      description: "Adds a 'tag', 'badge'."
    },
    pillValue: {
      type: String,
      description:
        "Defines value and colour of 'tag', 'badge'. Success, Info, Warn, Error, Default"
    },
    notification: Object,
    roleListItem: {
      type: Boolean,
      default: false,
      description: "Changes the semantics of the table row to a listitem role."
    },
    itemLabel: {
      type: String,
      default: "",
      description:
        "The label for the screenreader to identify the item if using role is listitem."
    },
    detailsLabel: {
      type: String,
      default: "Details",
      description:
        "The label for the screenreader to identify the active item details group if using role is listitem."
    },
    actionsLabel: {
      type: String,
      default: "Actions",
      description:
        "The label for the screenreader to identify the active item actions group if using role is listitem."
    },
    itemIndex: {
      type: Number,
      description: "Zero-based index of this item"
    },
    icon: {
      type: String,
      description: "Icon for this item, class name .icon-<icon>"
    },
    iconLabel: {
      type: String,
      description: "Icon label for this item"
    }
  },
  computed: {
    groupDetailsLabel: function () {
      return (
        this.itemLabel +
        " Item " +
        (this.itemIndex + 1) +
        " " +
        this.detailsLabel
      );
    },
    groupActionsLabel: function () {
      return (
        this.itemLabel +
        " Item " +
        (this.itemIndex + 1) +
        " " +
        this.actionsLabel
      );
    }
  },
  methods: {
    getErrors: function (errors) {
      let arr = [];

      if (errors.reasons) {
        for (let value of errors.reasons) {
          arr.push({
            level: 2,
            msg: value
          });
        }
      }

      if (errors.comments) {
        arr.push({
          level: 2,
          msg: errors.comments
        });
      }

      return arr;
    }
  }
};

export default mixin;
